export { default } from './index.vue';


// WEBPACK FOOTER //
// ./packages/wxc-countdown/index.js